export default (uuid) => {
  const r = uuid.slice(0, 11);
  const b = uuid.slice(12, 23);
  const g = uuid.slice(24, 35);
  const stringToHex = string => ((string.split("").reduce((a, c) => {
    return a + c.charCodeAt(0);
  }, 0) % 200) + 56).toString(16);
  return [stringToHex(r),stringToHex(g),stringToHex(b)].join("");
}
